import settings from "@/settings.json";

export const getContentFullUrl = (contentStorageName: string) => {
  return `${settings.ContentSource}${contentStorageName}`;
};
